module.exports = __webpack_public_path__ + "img/codeFooter.40b4d38a.png";